// src/components/pages/Pessoa/helpers/getPessoaTabsVisibility.js

export function getPessoaTabsVisibility(dados = {}, profile = {}) {
    const tamanhoCPForCNPJ = dados?.CPForCNPJ ? String(dados.CPForCNPJ).replace(/\D/g, '').length : 0;

    const isFisica = tamanhoCPForCNPJ > 0 && tamanhoCPForCNPJ <= 11;
    const isJuridica = tamanhoCPForCNPJ > 11;

    const ramoAtividade = localStorage.getItem('ramoAtividade');

    return {
        cabecalho: profile?.tabs?.cabecalho !== false,

        fisica: profile?.tabs?.fisica !== false && isFisica,

        documentos: profile?.tabs?.documentos !== false && isFisica,

        juridica: profile?.tabs?.juridica !== false && isJuridica,

        financeiro: profile?.tabs?.financeiro !== false,

        enderecos: profile?.tabs?.enderecos !== false,

        emails: profile?.tabs?.emails !== false,

        telefones: profile?.tabs?.telefones !== false,

        nomes: profile?.tabs?.nomes !== false && ramoAtividade === 'Governo',

        usuario: profile?.tabs?.usuario !== false,

        colaborador: profile?.tabs?.colaborador !== false && isFisica,

        funcionarios: profile?.tabs?.funcionarios !== false,

        filiais: profile?.tabs?.filiais !== false && isFisica,

        tabelaPrecos: profile?.tabs?.tabelaPrecos !== false,
    };
}
